import { Directive, ElementRef, Input, OnInit, Renderer2 } from "@angular/core";
import { MarkdownService } from "./markdown.service";

@Directive({
  selector: "[abMarkdown]",
})
export class MarkdownDirective implements OnInit {
  @Input("abMarkdown") public text: string;

  constructor(
    private elementRef: ElementRef,
    private markdownService: MarkdownService,
    private renderer: Renderer2,
  ) {}

  public ngOnInit() {
    const markdownHtml = this.markdownService.md.render(this.text);
    this.renderer.setProperty(
      this.elementRef.nativeElement,
      "innerHTML",
      markdownHtml,
    );
  }
}
